import React, { useState } from "react";
import ModalComponent from "../../../../components/Modals/modal";
import { useDispatch } from "react-redux";
import { farnersGenerateStatement } from "../../../../redux/Farmers/farmersActions";

const GenerateStatement = ({ id }) => {
  const [isClickGenerateStatement, setIsClickGenerateStatement] =
    useState(false);
  const dispatch = useDispatch();

  const handleGenerateStatement = () => {
    dispatch(
      farnersGenerateStatement({
        id: id,
      })
    );

    setTimeout(() => {
      setIsClickGenerateStatement(false);
    }, 800);
  };
  return (
    <div>
      {" "}
      <p
        className="py-[12px] px-[16px] text-sm font-medium leading-5 text-[#344335]"
        onClick={() => setIsClickGenerateStatement(true)}
      >
        Generate Statement
      </p>
      {/* GENERATE STATEMENT MODAL */}
      <ModalComponent
        title="Generate Statement"
        show={isClickGenerateStatement}
        showModal={() => setIsClickGenerateStatement(false)}
        subtitle="Are you sure you sure you want to generate a statement?"
      >
        <div className="pt-[32px] flex justify-end gap-[40px] items-center mb-[12px]">
          <p
            className="text-sm text-medium leading-5 text-[#5C715E]"
            onClick={() => setIsClickGenerateStatement(false)}
          >
            No
          </p>
          <button
            className="outline-0 bg-primary rounded-[8px] w-[62px] h-[40px] text-sm text-medium leading-5 text-white"
            onClick={handleGenerateStatement}
          >
            Yes
          </button>
        </div>
      </ModalComponent>
    </div>
  );
};

export default GenerateStatement;
